import React from "react";
import Config from "./include/Config";
import ClipList from "./ClipList";

export default class ListClipColumn extends React.Component {

    forceRefresh () {
        this.refs.child1.forceRefresh();
        this.refs.child2.forceRefresh();
    }

    render () {
        return (
            <div>
                <div className="split-vertical">
                    <div className="col-md-12 with-border-bottom">
                        {this.props.children}
                    </div>
                    <div className="col-md-12 clip-list first-level-clips with-border-bottom">
                        <ClipList title="New"
                                  ref="child1"
                                  date={this.props.date}
                                  currentEditKey={this.props.currentEditKey}
                                  statusLevel="tagging_level_1"
                                  onClick={this.props.onClick}
                                  refreshFrequency={2500}
                                  onLoadedClips={this.props.onLoadedClips}
                                  filteredGames={this.props.filteredGame}
                                  eventFilteringEnabled={false}
                                  onCreateNewClip={this.props.onCreateNewClip}
                        />
                    </div>
                    <div className="col-md-12 clip-list second-level-clips">
                        <ClipList title="Edited"
                                  ref="child2"
                                  date={this.props.date}
                                  currentEditKey={this.props.currentEditKey}
                                  statusLevel={Config.showAllInLevel2 ? "": "tagging_level_2"}
                                  onClick={this.props.onClick}
                                  refreshFrequency={15000}
                                  onLoadedClips={this.props.onLoadedClips}
                                  filteredGames={this.props.filteredGame}
                                  eventFilteringEnabled={true}
                        />
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/js/ListClipColumn.js